"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeePermission = exports.EmployeeType = void 0;
var EmployeeType;
(function (EmployeeType) {
    EmployeeType["COMPANY"] = "COMPANY";
    EmployeeType["BOOKKEEPER"] = "BOOKKEEPER";
    EmployeeType["PARTNER"] = "PARTNER";
})(EmployeeType = exports.EmployeeType || (exports.EmployeeType = {}));
var EmployeePermission;
(function (EmployeePermission) {
    EmployeePermission["CARD_ACCESS"] = "cardAccess";
    EmployeePermission["TEMPORARY_CARD_ACCESS"] = "temporaryCardAccess";
    EmployeePermission["DEDICATED_CARD_ACCESS"] = "dedicatedCardAccess";
})(EmployeePermission = exports.EmployeePermission || (exports.EmployeePermission = {}));
//# sourceMappingURL=employee.js.map